import styled from 'styled-components'
import * as BaseUI from '../../../ui/login.styled'

export const LoginButton = styled(BaseUI.LoginButton)`
  background: white;

  //min-width: 175px;

  &:hover {
    background: #F5F5F7;
  }

  &:active {
    background: #EBECEF;
  }
`

export const Icon = styled.svg`
  //border-radius: unset;
  //width: 22px;
  //height: 22px;
  width: 30px;
  height: 30px;
`
